/**
 * Environment-aware logging utility
 * Logs are only output in development mode
 */

const isDevelopment = import.meta.env.MODE === 'development';

export const logger = {
  /**
   * Development-only debug logging
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Development-only info logging
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args);
    }
  },

  /**
   * Development-only warning logging
   */
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  },

  /**
   * Error logging (shows in both dev and production for critical errors)
   */
  error: (...args: any[]) => {
    console.error('[ERROR]', ...args);
  },

  /**
   * Critical error logging (always shows, even in production)
   */
  critical: (...args: any[]) => {
    console.error('[CRITICAL]', ...args);
  }
};

/**
 * Development-only console.log replacement
 * Use this for temporary debugging that should be completely removed in production
 */
export const devLog = (...args: any[]) => {
  if (isDevelopment) {
    console.log('[DEV]', ...args);
  }
};